import { useEffect, useState } from "react";

// Accent key → Tailwind class for filled "tab" UI (drawer pulls, unread pills).
const accentTabBg: Record<string, string> = {
  emerald: "bg-emerald-600", blue: "bg-blue-600", purple: "bg-purple-600",
  rose: "bg-rose-600", amber: "bg-amber-600", indigo: "bg-indigo-600",
  cyan: "bg-cyan-600", orange: "bg-orange-600",
};

/**
 * Appearance settings consumed by the chat workspace. Initial values come from
 * the persisted `settings.appearance` blob; live updates arrive as window
 * events dispatched by the Appearance settings section
 * (`echo:accentChange`, `echo:drawerTabsChange`).
 */
export function useAppearanceSettings() {
  const [showDrawerTabs, setShowDrawerTabs] = useState<boolean>(() => {
    try { return JSON.parse(localStorage.getItem("settings") || "{}")?.appearance?.showDrawerTabs !== false; } catch { return true; }
  });
  const [accentKey, setAccentKey] = useState<string>(() => {
    try { return JSON.parse(localStorage.getItem("settings") || "{}")?.appearance?.accent || "emerald"; } catch { return "emerald"; }
  });

  useEffect(() => {
    const onDrawerTabsChange = (e: Event) => {
      setShowDrawerTabs((e as CustomEvent).detail !== false);
    };
    const onAccentChange = (e: Event) => {
      setAccentKey((e as CustomEvent<string>).detail || "emerald");
    };
    window.addEventListener("echo:drawerTabsChange", onDrawerTabsChange);
    window.addEventListener("echo:accentChange", onAccentChange);
    return () => {
      window.removeEventListener("echo:drawerTabsChange", onDrawerTabsChange);
      window.removeEventListener("echo:accentChange", onAccentChange);
    };
  }, []);

  const tabBgClass = accentTabBg[accentKey] ?? "bg-emerald-600";

  return { accentKey, tabBgClass, showDrawerTabs };
}


